import { createLoader, createParser, parseAsString, parseAsStringLiteral } from 'nuqs';

import { DEALS_SORT_DIRECTIONS, IN_WORK_OR_FINISHED_DEALS_SORT_FIELDS } from '@crm/entities/deal';
import { createIntegerRangeParser } from '@crm/shared/lib';

import type { UrlKeys } from 'nuqs';

export const inWorkDealsSearchParams = {
    page: createIntegerRangeParser({ min: 1 }).withDefault(1),
    query: parseAsString,
    showCompleted: createParser({
        parse: (value) => {
            if (value === 'true' || value === '1') {
                return true;
            }

            if (value === 'false' || value === '0') {
                return false;
            }

            return null;
        },
        serialize: String,
    }).withDefault(false),
    nextContactAtFrom: parseAsString,
    nextContactAtTo: parseAsString,
    paymentAtFrom: parseAsString,
    paymentAtTo: parseAsString,
    sort: parseAsStringLiteral(IN_WORK_OR_FINISHED_DEALS_SORT_FIELDS),
    direction: parseAsStringLiteral(DEALS_SORT_DIRECTIONS),
};

export const inWorkDealsSearchParamUrlKeys = {
    showCompleted: 'show_completed',
    nextContactAtFrom: 'next_contact_at_from',
    nextContactAtTo: 'next_contact_at_to',
    paymentAtFrom: 'payment_at_from',
    paymentAtTo: 'payment_at_to',
} satisfies UrlKeys<typeof inWorkDealsSearchParams>;

export const loadInWorkDealsSearchParams = createLoader(inWorkDealsSearchParams, {
    urlKeys: inWorkDealsSearchParamUrlKeys,
});
